import gql from 'graphql-tag'

export const GetProductsByIdQuery = gql`
  query GetProductByID($id: Int!, $teamStoreItem: String) {
    product(id: $id, teamStoreItem: $teamStoreItem, fromDetails: true) {
      id
      code
      yotpoId: yotpo_id
      name
      type: short_description
      shortDescription: short_description
      category_id
      mainCategory: main_category
      sport_id
      serie
      mpn
      flatlock
      chart
      core
      discontinued
      sizeTag: size_tag
      templateZip: template_zip
      branding
      title
      comingSoon: coming_soon
      comingSoonLabel: coming_soon_label
      colorGenders: color_genders
      onlyProDesign: only_pro_design
      intakeAdmin: intake_admin
      hasInventory: has_inventory
      inventoryJson: inventory_json
      bibBrace {
        white
        black
      }
      binding {
        white
        black
      }
      zipper {
        white
        black
      }
      zipper2 {
        white
        black
      }
      colors {
        id
        name
        image
      }
      sports {
        id
        name
      }
      gender_id
      evo
      customizable: design_center
      customLink: custom_link
      description
      descriptionRich: description_rich
      mediaFiles: media_files {
        id
        url
        urlMobile: url_mobile
        width
        isText: is_text
        richText: rich_text
        isCarousel: is_carousel
        backgroundColor: background_color
        verticalAlign: vertical_align
        altDescription: alt_description
        cssStyle: css_style
        backgroundImage: background_image
      }
      hideFitStyles: hide_fit_styles
      youthCombined: youth_combined
      weight
      genders {
        id
        name: gender
      }
      fitStyles {
        id
        name: description
        info
      }
      sizeRange: size_range {
        id
        name
        isYouth: is_youth
      }
      upgradeOne: upgrade_one {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeTwo: upgrade_two {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeThree: upgrade_three {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      isTopProduct
      images: pictures2 {
        front: front_image
        back: back_image
        left: left_image
        right: right_image
        model_front
        model_back
        genderId: gender_id
        colorId: color_id
        thumbnail
        preview
        color_id
      }
      priceRange {
        price
        quantity
        abbreviation
        shortName: short_name
      }
      yotpoAverageScore {
        total: total_reviews
        averageScore: average_score
      }
      retailMen: men_retail
      retailWomen: women_retail
      vinylMaterials: vinyl_materials
      relatedItemTag: related_item_tag
      active
      two_pieces
      infoFlag: info_flag
      infoMessage: info_message
      teamPrice: team_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      resellerPrice: reseller_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      totalOrders: total_orders
      teamEnable: team_enable
      teamName: team_name
      teamOnDemand: team_on_demand_mode
      teamGracePeriod: team_grace_period
      teamCouponReminder: team_coupon_reminder
      team_from_ca
      fixedPrice: team_fixed_price
      isReseller: is_reseller
      ownedDesign: owned_design
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        countryName: country_name
        countryCode: country_code
      }
      reseller {
        id
        status
        currency
        inline
        comission
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductDetail/data.ts